export default {
  menu: {
    home: '首页',
    fee: '费用',
    myAccount: '我的账户',
    feeDetail: '费用明细',
    workOrder: '服务台',
    serviceDesk: '代操作服务台',
    message: '消息',
    allMessage: '全部消息',
    unreadMessage: '未读消息',
    readMessage: '已读消息',
    manage: '企业管理',
    resource: '资源管理',
    staff: '员工管理',
    staffSetting: '员工设置',
    staffManage: '员工管理',
    roleSetting: '角色设置',
    inspectJob: '检查工作',
    notice: '站内新闻',
    noticeNews: '公告&新闻',
    newFunction: '近期重要功能',
    userCenter: '用户中心',
    information: '基本信息',
    authentication: '实名认证',
    score: '会员积分',
    authenticationByPerson: '个人实名认证',
    authenticationByCompany: '公司实名认证',
    authenticationByGovernment: '政府实名认证',
    authenticationByOrganization: '其他组织实名认证',
    seeAuthentication: '查看认证信息',
    fastAuthentication: '快速认证',
    order: '订单',
    buyKey: '一键购买',
    renew: '产品续费',
    levelUp: '产品升级',
    popularize: '引流工具',
    statistics: '概况',
    bindRegister: '平台信息管理',
    microPromotion: '新媒体矩阵',
    suitui: '随推',
    businessPromotion: '商机推广',
    batchGeneration: '批量生成商机',
    areaSelect: '选择投放区域',
    evaluation: '口碑测评',
    bootPage: '引导页',
    webScore: '网站分析结果',
    contrast: '同行对比',
    marketing: '再营销',
    websiteManage: '站点管理',
    experience: '再营销体验',
    // seeResult: '看结果',
    seeBusinessResult: '云引擎商机推广结果',
    popularizeResult: '做推广结果',
    business: '商机发布',
    businessDetail: '关键词发布详情',
    businessRanking2: '商机发布详情',
    miniprogramResult: '小程序结果',
    marketingResult: '再营销结果',
    zhentuiResult: '臻推宝结果',
    ideaLaunch: '创意投放',
    materialList: '素材配置',
    auditMaterial: '再营销资质审核',
    insertWebsite: '添加站点',
    businessEdit: '商机编辑',
    articleList: '文章管理',
    imageList: '图片管理',
    rejectList: '驳回列表',
    businessHelper: "智能商机发布",
    autoPublishSettings: "云引擎商机推广结果",
    platform: '电商交易工具',
    chineseStation: '品牌官网',
    foreignStation: '外文站',
    xcx: '小程序',
    recyclebin: '回收站',
    smartShop: '智能店铺',
    industryPosition: '行业定位',
    selectTemplate: '选择模板',
    openMIP: '开通MIP',
    openAMP: '开通AMP',
    dataFill: '资料填写',
    shopTemplate: '店铺模板',
    shopSet: '店铺设置',
    seoSet: 'seo设置',
    friendLink: '友情链接',
    lookShop: '查看店铺',
    contentManagement: '内容管理',
    productManagement: '产品',
    caseManagement: '案例',
    newsManagement: '新闻',
    webManagement: '网站管理',
    enquiryManagement: '询盘管理',
    xcxList: '小程序',
    xcxDetail: '小程序详情',
    xcxOpen: '开通',
    xcxSelectTemplate: '选择模板',
    ideaManage: '创意管理',
    ideaGroupManage: '创意管理',
    ideaEdit: '创意编辑',
    openFinish: '开通完成',
    preview: '预览',
    monthly: '查看月报',
    keywordRanking: "关键词排名",
    KeyWordsManagement: '关键词管理',
    aiExtension: "拓词设置",
    foreign: '外文站',
    selectLang: '语言选择',
    confirmLang: '语言确认',
    flowStatistics: '流量统计',
    materialConfig: '素材配置',
    textMaterialManange: '文字素材管理',
    imgMaterialManange: '图片素材配置',
    introductionPage: '介绍页',
    advertisingSet: '广告设置',
    articlePromote: '文章推广',
    promotionRecord: '推广记录',
    picktrueHouse: '图库',
    siteInformationSetting: '站点信息配置',
    bindRegister1: '平台绑定',
    userManage: '客户管理',
    transformation: '企业口碑工具',
    transformationIndex: '概况',
    goodNews: '优质新闻媒体',
    normalNews: '普通新闻媒体',
    digitalMap: '电子地图标注',
    allianceNews: '联盟新闻',
    zhenkoubei: '口碑问答',
    zkbInformationSetting: '口碑问答信息配置',
    zkbPublishResults: '口碑问答发布结果',
    zkbReason: '常见驳回问答类型',
    keyword: '智能拓词',
    utilities: '实用工具',
    utilitiesIndex:"全部",
    utilitiesList: '工具目录',
    drainage: "推广引流",
    promotionList: "推文列表",
    keywordList: "关键词库管理"
  },
  content: {
    main: '这里是内容'
  }
}
